import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent'
import PeriodeMonitoringService from '../PeriodeMonitoringService'
import BerechtigteListService from '../../../services/BerechtigteListService'
import PeriodeMonitoringVNBColumns from './PeriodeMonitoringVNBColumns'
import PeriodeMonitoringVNBDto from './PeriodeMonitoringVNBDto'
import '@isceco/widget-library2/basic-elements/List/List'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter'

export default class PeriodeMonitoringVNB extends WebComponent {

  constructor() {
    super()
    this.periodeMonitoringService = new PeriodeMonitoringService()
  }

  get translationFile() {
    return './views/PeriodeMonitoring/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.periodeId = getNavigationHash()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.periodeMonitoringService.getBackendListUrl(`${getNavigationId()}/vnb`)
    ).then(url => {
      this.monitoringVnbUrl = url
    }).catch(() => {
      this.monitoringVnbUrl = ''
    }).finally(() => {
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('navigation.verteilnetzbetreiber')}"
                    size="medium"
      ></isceco-title>

      <isceco-filter-group>
        <isceco-string-filter key="vnb"
                              label="${this.i18n.translate('monitoring.periode.header.vnb')}"
                              minchars="2"
        ></isceco-string-filter>
      </isceco-filter-group>
      <isceco-list id="periode-vnb-list"
                   url="${this.monitoringVnbUrl}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toDto}"
                   .columns="${PeriodeMonitoringVNBColumns.getColumns()}"
                   order="asc"
                   sort="vnb"
      ></isceco-list>
    `
  }

  _toDto = json => new PeriodeMonitoringVNBDto(json)

}

customElements.define('eko-frontend-kontingentierung-periode-vnb', PeriodeMonitoringVNB)
